import firebase from "firebase/app";
import "firebase/auth";

export function getUser(): firebase.User | null {
  return firebase.app().auth().currentUser;
}
